import "./SupplierAndBuyerPortal.module.css";
import Header from "@/reusable_sections/Header";
import SupplierPortal from "./sections/SupplierPortal";
import BuyerPortal from "./sections/BuyerPortal";
import KeyFeaturesComparison from "./sections/KeyFeaturesComparison";
import GetStarted from "./sections/GetStarted";
import Footer from "@/reusable_sections/Footer";
export default function SupplierAndBuyerPortalPage() {
  return <div>
      <Header />
      <SupplierPortal />
      <BuyerPortal />
      <KeyFeaturesComparison />
      <GetStarted />
      <Footer />
    </div>;
}